
// import { useEffect, useState } from "react";
// import { Menu, MenuItem, Select } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import MyListingCard from "./myListingCard";
// import SellerConfirmed from "./SellerConfirmed";
// import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
// import { getUserInfo } from "../../apis/General/users";
// import { useSelector } from "react-redux";
// import EnergySharingContract from "../../Abi/EnergySharingContract.json";
// import Web3 from "web3";

// export default function MyListings({ itemsPerPage, currentPage, setCurrentPage }) {
//   const auth = useSelector((state) => state.auth);
//   const navigate = useNavigate();

//   const [open, setOpen] = useState(false);
//   const [listing, setListing] = useState([]);
//   const [anchorElFour, setAnchorElFour] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [selectedListing, setSelectedListing] = useState(null);
//   const [actionType, setActionType] = useState(""); // "pause", "resume", "delete"
//   const [account, setAccount] = useState(null);
//   const [web3, setWeb3] = useState(null);
//   const [contract, setContract] = useState(null);
//   const openerFour = Boolean(anchorElFour);
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [pauseOpen, setPauseOpen] = useState(false);
//   const [totalItems, setTotalItems] = useState(0);

//   useEffect(() => {
//     if (window.ethereum) {
//       const web3Instance = new Web3(window.ethereum);
//       setWeb3(web3Instance);
//       window.ethereum
//         .request({ method: "eth_requestAccounts" })
//         .then((accounts) => setAccount(accounts[0]))
//         .catch((err) => {
//           alert(
//             "Please allow access to your MetaMask wallet to enable you exchange your CCRT"
//           );
//           console.error("User denied account access", err);
//         });
//     } else {
//       console.error(
//         "MetaMask is not installed. Please install it to use this app."
//       );
//     }
//   }, []);

//   const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";
//   const contractABI = EnergySharingContract.abi;

//   useEffect(() => {
//     if (web3) {
//       const contractInstance = new web3.eth.Contract(contractABI, contractAddress);
//       setContract(contractInstance);
//     }
//   }, [web3]);

//   const handleGetAllListings = async (page = 1) => {
//     try {
//       const offset = (page - 1) * itemsPerPage;
//       console.log("Fetching my listings for MY LISTINGS tab...");

//       if (!account) {
//         console.error("No wallet connected. Please connect your MetaMask wallet.");
//         return;
//       }

//       const integration = new EnergyTradingIntegration("seller");
//       await integration.init();

//       console.log("Fetching listings for seller:", account);
//       const { listings, totalCount } = await integration.getSellerListings(
//         account,
//         offset,
//         itemsPerPage
//       );

//       console.log("Raw listings from blockchain:", listings);

//       // Debug: Check status of each listing
//       listings?.forEach((listing, index) => {
//         console.log(`Listing ${index}: ID ${listing.listingId}, Status: ${listing.status}, Type: ${typeof listing.status}`);
//       });

//       console.log("Total count:", totalCount);

//       // Create a new array before reversing
//       const reversedListings = listings ? [...listings].reverse() : [];
//       console.log("Processed listings:", reversedListings);

//       setListing(reversedListings);
//       console.log("State should be updated now");
//       setTotalItems(Number(totalCount));

//     } catch (error) {
//       console.error("Failed to fetch my listings:", error);
//     }
//   };

//   useEffect(() => {
//     if (account) {
//       handleGetAllListings(currentPage);
//     }
//   }, [account, currentPage]);

//   const handleCloseFour = () => {
//     setAnchorElFour(null);
//     setSelectedListing(null);
//   };

//   const handleClickFour = (event, listingItem) => {
//     console.log("Clicked listing item:", listingItem);
//     console.log("Raw status:", listingItem?.status);
//     console.log("Processed status:", getListingStatus(listingItem?.status));
//     setAnchorElFour(event.currentTarget);
//     setSelectedListing(listingItem);
//   };

//   // const handleClickFour = (event, listingItem) => {
//   //   setAnchorElFour(event.currentTarget);
//   //   setSelectedListing(listingItem);
//   // };

//   // const getListingStatus = (statusCode) => {
//   //   switch (statusCode) {
//   //     case 0:
//   //       return "in-progress";
//   //     case 1:
//   //       return "paused";
//   //     default:
//   //       return "pending";
//   //   }
//   // };

//   const getListingStatus = (statusCode) => {
//     console.log("getListingStatus received:", statusCode, "type:", typeof statusCode);

//     // Convert to number if it's a string
//     const code = typeof statusCode === 'string' ? parseInt(statusCode) : statusCode;

//     switch (code) {
//       case 0:
//         return "in-progress";
//       case 1:
//         return "paused";
//       default:
//         return "pending";
//     }
//   };

//   const handleListingAction = async () => {
//     console.log("handleListingAction called with:", {
//       selectedListing,
//       actionType
//     });

//     if (!selectedListing) {
//       alert("No wallet connected. Please connect your MetaMask wallet.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const integration = new EnergyTradingIntegration("seller");
//       await integration.init();

//       switch (actionType) {
//         case "pause":
//           await integration.pauseListing(selectedListing.listingId);
//           alert("Listing paused successfully");
//           break;
//         case "resume":
//           await integration.resumeListing(selectedListing.listingId);
//           alert("Listing resumed successfully");
//           break;
//         case "delete":
//           await integration.cancelListing(selectedListing.listingId);
//           alert("Listing deleted successfully");
//           break;
//         default:
//           alert("Invalid action");
//           return;
//       }

//       // Refresh listings immediately
//       await handleGetAllListings(currentPage);

//       // Close modals and clear state
//       setOpen(false);
//       setDeleteOpen(false);
//       setPauseOpen(false);
//       setSelectedListing(null);
//       setActionType("");
//       setLoading(false);

//     } catch (error) {
//       console.error(`Failed to ${actionType} listing:`, error);
//       alert(`Failed to ${actionType} listing: ${error.message}`);
//       setLoading(false);
//       // Close modals even on error
//       setOpen(false);
//       setDeleteOpen(false);
//       setPauseOpen(false);
//       setSelectedListing(null);
//       setActionType("");
//     }
//   };

//   // Cancel button functions
//   const handleCancelAction = () => {
//     setOpen(false);
//     setSelectedListing(null);
//     setActionType("");
//   };

//   const handleCancelDelete = () => {
//     setDeleteOpen(false);
//     setSelectedListing(null);
//     setActionType("");
//   };

//   const handlePauseClick = () => {
//     console.log("Pause clicked, selectedListing:", selectedListing);
//     setActionType("pause");
//     setOpen(true);
//     setAnchorElFour(null); // Just close the menu
//   };

//   const handleResumeClick = () => {
//     console.log("Resume clicked, selectedListing:", selectedListing);
//     setActionType("resume");
//     setOpen(true);
//     setAnchorElFour(null); // Just close the menu
//   };

//   const handleDeleteClick = () => {
//     console.log("Delete clicked, selectedListing:", selectedListing);
//     setActionType("delete");
//     setDeleteOpen(true);
//     setAnchorElFour(null); // Just close the menu
//   };

//   const handleEditClick = () => {
//     if (selectedListing) {
//       navigate(`/edit-listing/${selectedListing.listingId}`);
//       window.scrollTo(0, 0);
//     }
//     handleCloseFour();
//   };

//   useEffect(() => {
//     handleGetAllListings();
//   }, []);

//   const getActionTitle = () => {
//     switch (actionType) {
//       case "pause":
//         return "Pause Listing";
//       case "resume":
//         return "Resume Listing";
//       case "delete":
//         return "Delete Listing";
//       default:
//         return "Confirm Action";
//     }
//   };

//   const getActionSubtitle = () => {
//     // Debug: log the selectedListing to see the actual structure
//     console.log("Selected listing in getActionSubtitle:", selectedListing);

//     // Use the quantity property since you confirmed it exists
//     const energyAmount = selectedListing?.quantity || 0;

//     console.log("Energy amount:", energyAmount);

//     switch (actionType) {
//       case "pause":
//         return `You want to pause your listing to sell ${energyAmount}kWh of energy. If you didn't initiate this action click cancel.`;
//       case "resume":
//         return `You want to resume your listing to sell ${energyAmount}kWh of energy. If you didn't initiate this action click cancel.`;
//       case "delete":
//         return `You want to delete your listing to sell ${energyAmount}kWh of energy. This action cannot be undone. If you didn't initiate this action click cancel.`;
//       default:
//         return "Are you sure you want to perform this action?";
//     }
//   };

//   const getActionButtonText = () => {
//     switch (actionType) {
//       case "pause":
//         return ["Cancel", "Pause listing"];
//       case "resume":
//         return ["Cancel", "Resume listing"];
//       case "delete":
//         return ["Cancel", "Delete listing"];
//       default:
//         return ["Cancel", "Confirm"];
//     }
//   };

//   const Pagination = () => {
//     const totalPages = Math.ceil(totalItems / itemsPerPage);


//     return (
//       <div className="pagination">
//         <button
//           onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//           disabled={currentPage === 1}
//         >
//           Previous
//         </button>

//         <span>
//           Page {currentPage} of {totalPages}
//         </span>

//         <button
//           onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//           disabled={currentPage === totalPages}
//         >
//           Next
//         </button>
//       </div>
//     );
//   };


//   return (
//     <>
//       <table className="energyOrders__inner__card__table">
//         <tbody>
//           {listing?.map((listingItem) => (
//             <MyListingCard
//               listing={listingItem}
//               key={listingItem?.listingId}
//               status={getListingStatus(listingItem?.status)}
//               handleClickFour={(event) => handleClickFour(event, listingItem)}
//             />
//           ))}
//         </tbody>

//         <Menu
//           id="basic-menu"
//           anchorEl={anchorElFour}
//           open={openerFour}
//           onClose={handleCloseFour}
//           MenuListProps={{
//             "aria-labelledby": "basic-button",
//           }}
//         >
//           <MenuItem
//             sx={{
//               width: "18.4rem",
//               fontSize: "1.4rem",
//               fontFamily: "Inter",
//               fontWeight: "500",
//               backgroundColor: "#fff !important",
//               "&:hover": {
//                 color: "#063",
//                 backgroundColor: "#fff",
//               },
//             }}
//             className="subMenu"
//             onClick={handleEditClick}
//           >
//             Edit
//           </MenuItem>

//           {/* Show Pause ONLY when status is "pending" */}
//           {getListingStatus(selectedListing?.status) === "pending" && (
//             <MenuItem
//               sx={{
//                 width: "18.4rem",
//                 fontSize: "1.4rem",
//                 fontFamily: "Inter",
//                 fontWeight: "500",
//                 backgroundColor: "#fff !important",
//                 "&:hover": {
//                   color: "#063",
//                   backgroundColor: "#fff",
//                 },
//               }}
//               className="subMenu"
//               onClick={handlePauseClick}
//             >
//               Pause
//             </MenuItem>
//           )}

//           {/* Show Resume ONLY when status is "paused" */}
//           {getListingStatus(selectedListing?.status) === "paused" && (
//             <MenuItem
//               sx={{
//                 width: "18.4rem",
//                 fontSize: "1.4rem",
//                 fontFamily: "Inter",
//                 fontWeight: "500",
//                 backgroundColor: "#fff !important",
//                 "&:hover": {
//                   color: "#063",
//                   backgroundColor: "#fff",
//                 },
//               }}
//               className="subMenu"
//               onClick={handleResumeClick}
//             >
//               Resume
//             </MenuItem>
//           )}

//           <MenuItem
//             sx={{
//               width: "18.4rem",
//               fontSize: "1.4rem",
//               fontFamily: "Inter",
//               fontWeight: "500",
//               backgroundColor: "#fff !important",
//               "&:hover": {
//                 color: "#063",
//                 backgroundColor: "#fff",
//               },
//             }}
//             className="subMenu"
//             onClick={handleDeleteClick}
//           >
//             Delete
//           </MenuItem>
//         </Menu>

//       </table>
//       <Pagination />
//       {/* Modal for Pause/Resume actions */}
//       <SellerConfirmed
//         title={getActionTitle()}
//         subtitle={getActionSubtitle()}
//         buttonTexts={getActionButtonText()}
//         buttonFunctions={[
//           handleCancelAction,
//           handleListingAction
//         ]}
//         open={open}
//         setOpen={setOpen}
//       />

//       {/* Modal for Delete action */}
//       <SellerConfirmed
//         title={getActionTitle()}
//         subtitle={getActionSubtitle()}
//         buttonTexts={getActionButtonText()}
//         buttonFunctions={[
//           handleCancelDelete,
//           handleListingAction
//         ]}
//         open={deleteOpen}
//         setOpen={setDeleteOpen}
//       />
//     </>
//   );
// }
import { useEffect, useState } from "react";
import { Menu, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MyListingCard from "./myListingCard";
import SellerConfirmed from "./SellerConfirmed";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { getUserInfo } from "../../apis/General/users";
import { useSelector } from "react-redux";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";
import Web3 from "web3";

export default function MyListings({ itemsPerPage, currentPage, setCurrentPage }) {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [listing, setListing] = useState([]);
  const [anchorElFour, setAnchorElFour] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [actionType, setActionType] = useState(""); // "pause", "resume", "delete"
  const [account, setAccount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const openerFour = Boolean(anchorElFour);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [pauseOpen, setPauseOpen] = useState(false);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          alert(
            "Please allow access to your MetaMask wallet to enable you exchange your CCRT"
          );
          console.error("User denied account access", err);
        });
    } else {
      console.error(
        "MetaMask is not installed. Please install it to use this app."
      );
    }
  }, []);

  const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";
  const contractABI = EnergySharingContract.abi;

  useEffect(() => {
    if (web3) {
      const contractInstance = new web3.eth.Contract(contractABI, contractAddress);
      setContract(contractInstance);
    }
  }, [web3]);

  // In your MyListings component, update the handleGetAllListings function:
  const handleGetAllListings = async (page = 1) => {
    try {
      const offset = (page - 1) * itemsPerPage;

      if (!account) {
        console.error("No wallet connected. Please connect your MetaMask wallet.");
        return;
      }

      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      const { listings, totalCount } = await integration.getSellerListings(
        account,
        offset,
        itemsPerPage
      );

      if (listings && listings.length > 0) {
        listings.forEach((item, index) => {
          console.log(`Listing ${index}:`, {
            id: item.listingId,
            rawStatus: item.status,
            rawStatusString: item.status?.toString(),
            rawStatusType: typeof item.status,
            processedStatus: getListingStatus(item.status)
          });
        });
      } else {
        console.log("No listings found");
      }

      // Create a new array before reversing
      const reversedListings = listings ? [...listings].reverse() : [];
      setListing(reversedListings);
      setTotalItems(Number(totalCount));

    } catch (error) {
      console.error("Failed to fetch my listings:", error);
    }
  };


  useEffect(() => {
    if (account) {
      handleGetAllListings(currentPage);
    }
  }, [account, currentPage]);

  const handleCloseFour = () => {
    setAnchorElFour(null);
    setSelectedListing(null);
  };

  const handleClickFour = (event, listingItem) => {
    console.log("Menu clicked - Listing:", listingItem);
    console.log("Raw status:", listingItem?.status, "Type:", typeof listingItem?.status);
    console.log("Processed status:", getListingStatus(listingItem?.status));

    setAnchorElFour(event.currentTarget);
    setSelectedListing(listingItem);
  };

  const getListingStatus = (statusCode) => {

    if (statusCode === null || statusCode === undefined || statusCode === '') {
      console.log("🔍 Returning 'pending' for null/undefined");
      return "pending";
    }

    // Convert to number, handling BigInt
    let code;
    if (typeof statusCode === 'bigint') {
      code = Number(statusCode);
    } else if (typeof statusCode === 'string') {
      code = parseInt(statusCode);
    } else {
      code = statusCode;
    }

    // Handle NaN case
    if (isNaN(code)) {
      return "pending";
    }


    switch (code) {
      case 0:
        return "pending"; // Available for purchase
      case 1:
        return "paused"; // Manually paused by seller
      case 2:
        return "in-progress"; // Transaction has begun (should disable menu)
      case 3:
        return "completed"; // Fully sold/completed
      default:
        return "pending";
    }
  };


  const handleListingAction = async () => {
    console.log("handleListingAction called with:", {
      selectedListing,
      actionType
    });

    if (!selectedListing) {
      alert("No listing selected");
      return;
    }

    setLoading(true);
    try {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      let transaction;
      switch (actionType) {
        case "pause":
          transaction = await integration.pauseListing(selectedListing.listingId);
          console.log("Pause transaction:", transaction);
          alert("Listing paused successfully");
          break;
        case "resume":
          transaction = await integration.resumeListing(selectedListing.listingId);
          console.log("Resume transaction:", transaction);
          alert("Listing resumed successfully");
          break;
        case "delete":
          transaction = await integration.cancelListing(selectedListing.listingId);
          console.log("Delete transaction:", transaction);
          alert("Listing deleted successfully");
          break;
        default:
          alert("Invalid action");
          return;
      }

      // Wait for blockchain confirmation then refresh
      console.log("Waiting for blockchain confirmation...");
      await new Promise(resolve => setTimeout(resolve, 3000)); // Wait 3 seconds

      // Force refresh listings
      await handleGetAllListings(currentPage);
      console.log("Listings refreshed after action");

    } catch (error) {
      console.error(`Failed to ${actionType} listing:`, error);
      alert(`Failed to ${actionType} listing: ${error.message}`);
    } finally {
      setLoading(false);
      // Close modals and clear state
      setOpen(false);
      setDeleteOpen(false);
      setPauseOpen(false);
      setSelectedListing(null);
      setActionType("");
    }
  };

  // Cancel button functions
  const handleCancelAction = () => {
    setOpen(false);
    setSelectedListing(null);
    setActionType("");
  };

  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setSelectedListing(null);
    setActionType("");
  };

  const handlePauseClick = () => {
    console.log("Pause clicked, selectedListing:", selectedListing);
    setActionType("pause");
    setOpen(true);
    setAnchorElFour(null);
  };

  const handleResumeClick = () => {
    console.log("Resume clicked, selectedListing:", selectedListing);
    setActionType("resume");
    setOpen(true);
    setAnchorElFour(null);
  };

  const handleDeleteClick = () => {
    console.log("Delete clicked, selectedListing:", selectedListing);
    setActionType("delete");
    setDeleteOpen(true);
    setAnchorElFour(null);
  };

  const handleEditClick = () => {
    if (selectedListing) {
      // navigate(`/edit-listing/${selectedListing.listingId}`);
      navigate("/edit-listing")
      window.scrollTo(0, 0);
    }
    handleCloseFour();
  };

  useEffect(() => {
    handleGetAllListings();
  }, []);

  const getActionTitle = () => {
    switch (actionType) {
      case "pause":
        return "Pause Listing";
      case "resume":
        return "Resume Listing";
      case "delete":
        return "Delete Listing";
      default:
        return "Confirm Action";
    }
  };

  const getActionSubtitle = () => {
    const energyAmount = selectedListing?.quantity || 0;

    switch (actionType) {
      case "pause":
        return `You want to pause your listing to sell ${energyAmount}kWh of energy. If you didn't initiate this action click cancel.`;
      case "resume":
        return `You want to resume your listing to sell ${energyAmount}kWh of energy. If you didn't initiate this action click cancel.`;
      case "delete":
        return `You want to delete your listing to sell ${energyAmount}kWh of energy. This action cannot be undone. If you didn't initiate this action click cancel.`;
      default:
        return "Are you sure you want to perform this action?";
    }
  };

  const getActionButtonText = () => {
    switch (actionType) {
      case "pause":
        return ["Cancel", "Pause listing"];
      case "resume":
        return ["Cancel", "Resume listing"];
      case "delete":
        return ["Cancel", "Delete listing"];
      default:
        return ["Cancel", "Confirm"];
    }
  };

  const Pagination = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  //  menu disabling logic
  const isMenuDisabled = (listingItem) => {
    const status = getListingStatus(listingItem?.status);
    // console.log("🚫 Menu disabled check:", {
    //   listingId: listingItem?.listingId,
    //   rawStatus: listingItem?.status,
    //   processedStatus: status,
    //   disabled: status === "in-progress" || status === "completed"
    // });
    // Disable menu for both "in-progress" and "completed" listings
    return status === "in-progress" || status === "completed";
  };


  return (
    <>

      <table className="energyOrders__inner__card__table">
        <tbody>
          {listing?.map((listingItem) => (
            <MyListingCard
              listing={listingItem}
              key={listingItem?.listingId}
              status={getListingStatus(listingItem?.status)}
              handleClickFour={(event) => handleClickFour(event, listingItem)}
              isMenuDisabled={isMenuDisabled(listingItem)}
            />
          ))}
        </tbody>
        <Menu
          id="basic-menu"
          anchorEl={anchorElFour}
          open={openerFour}
          onClose={handleCloseFour}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >


          <MenuItem
            sx={{
              width: "18.4rem",
              fontSize: "1.4rem",
              fontFamily: "Inter",
              fontWeight: "500",
              backgroundColor: "#fff !important",
              "&:hover": {
                color: "#063",
                backgroundColor: "#fff",
              },
            }}
            className="subMenu"
            onClick={handleEditClick}
          >
            Edit
          </MenuItem>

          {/* Show Pause for pending listings (status 0) */}
          {getListingStatus(selectedListing?.status) === "pending" && (
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",
                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={handlePauseClick}
            >
              Pause
            </MenuItem>
          )}

          {/* Show Resume for paused listings (status 1) */}
          {getListingStatus(selectedListing?.status) === "paused" && (
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",
                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={handleResumeClick}
            >
              Resume
            </MenuItem>
          )}

          {/* Show Delete for pending and paused listings only */}
          {(getListingStatus(selectedListing?.status) === "pending" ||
            getListingStatus(selectedListing?.status) === "paused") && (
              <MenuItem
                sx={{
                  width: "18.4rem",
                  fontSize: "1.4rem",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  backgroundColor: "#fff !important",
                  "&:hover": {
                    color: "#063",
                    backgroundColor: "#fff",
                  },
                }}
                className="subMenu"
                onClick={handleDeleteClick}
              >
                Delete
              </MenuItem>
            )}
        </Menu>
      </table>
      <Pagination />

      {/* Modal for Pause/Resume actions */}
      <SellerConfirmed
        title={getActionTitle()}
        subtitle={getActionSubtitle()}
        buttonTexts={getActionButtonText()}
        buttonFunctions={[
          handleCancelAction,
          handleListingAction
        ]}
        open={open}
        setOpen={setOpen}
      />

      {/* Modal for Delete action */}
      <SellerConfirmed
        title={getActionTitle()}
        subtitle={getActionSubtitle()}
        buttonTexts={getActionButtonText()}
        buttonFunctions={[
          handleCancelDelete,
          handleListingAction
        ]}
        open={deleteOpen}
        setOpen={setDeleteOpen}
      />
    </>
  );
}